import { ID } from '../../utils/codecUtils';
import { queueRuleSchema } from '../models/queueRule.schema';

export const get = (ruleId: ID) => {
  return {
    endpoint: `/rules/${ruleId}`,
    method: 'GET',
    responseSchema: queueRuleSchema,
  } as const;
};
